import apiInstance from "services/api/api";
import { IUserPostOrder } from "shared/interfaces/Order.interface";

export default async (order: IUserPostOrder) =>
  await apiInstance.post("/orders", order);
